export const AJAX_PAGE_PER_COUNT = 80; //ajax request 시의 data page set 단위 (pc/mo, tot/tab 에 따라 다름.)
export const USE_THUMB_SIZE = 200;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/consts/configs.js
 **/